import StyledSvg from '@gef-ui/material-svg-shared/StyledSvg';
import * as React from 'react';
const SvgFileUploadPositiveFidelityHigh = (props)=>{
    const id = React.useId();
    return /*#__PURE__*/ React.createElement(StyledSvg, {
        xmlns: "http://www.w3.org/2000/svg",
        width: 256,
        height: 256,
        fill: "none",
        viewBox: "0 0 256 256",
        ...props
    }, /*#__PURE__*/ React.createElement("g", {
        clipPath: `url(#file-upload-positive-fidelity-high_svg__a-${id})`
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#E4EFFA",
        d: "M256 128C256 57.308 198.692 0 128 0S0 57.308 0 128s57.308 128 128 128 128-57.308 128-128"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#fff",
        d: "M192.961 91.043v101.783c0 2.954-.598 5.879-1.761 8.608a22.5 22.5 0 0 1-5.015 7.297 23.2 23.2 0 0 1-7.507 4.876 23.7 23.7 0 0 1-8.854 1.712H83.137a23.7 23.7 0 0 1-8.854-1.712 23.2 23.2 0 0 1-7.506-4.876 22.5 22.5 0 0 1-5.016-7.297A22 22 0 0 1 60 192.826V60.08c0-2.954.599-5.879 1.761-8.608a22.5 22.5 0 0 1 5.016-7.297 23.2 23.2 0 0 1 7.506-4.876 23.7 23.7 0 0 1 8.854-1.712h55.111z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#C3DCBF",
        d: "M140.652 39.936c-4.437 11.42-14.704 28.93-4.351 43.648 2.69 4.082 19.076 10.392 29.359 14.033 6.564 2.325 11.964 9.651 11.964 16.628l.861 67.939c0 12.422-10.352 22.487-23.13 22.487H68.668c-1.928 0-3.8-.236-5.59-.668 4.117 6.995 11.77 11.313 20.06 11.321h86.686c12.783.003 23.147-10.073 23.143-22.501V91.038z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#4C875B",
        d: "m138.251 37.59-7.19 28.098a13.65 13.65 0 0 0-.226 5.715 13.8 13.8 0 0 0 2.138 5.323 14.1 14.1 0 0 0 4.144 4.038 14.5 14.5 0 0 0 5.454 2.076l50.393 8.206z"
    }), /*#__PURE__*/ React.createElement("rect", {
        width: 37.522,
        height: 7.899,
        x: 79.749,
        y: 83.009,
        fill: "#4C875B",
        rx: 3.95
    }), /*#__PURE__*/ React.createElement("rect", {
        width: 75.045,
        height: 7.899,
        x: 79.749,
        y: 108.682,
        fill: "#385B66",
        rx: 3.95
    }), /*#__PURE__*/ React.createElement("rect", {
        width: 78.994,
        height: 7.899,
        x: 79.749,
        y: 134.355,
        fill: "#385B66",
        rx: 3.95
    }), /*#__PURE__*/ React.createElement("rect", {
        width: 65.17,
        height: 7.899,
        x: 79.749,
        y: 160.028,
        fill: "#385B66",
        rx: 3.95
    }), /*#__PURE__*/ React.createElement("circle", {
        cx: 124.218,
        cy: 217.1,
        r: 31.598,
        fill: "#4C875B",
        transform: "rotate(150 124.218 217.1)"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#fff",
        fillRule: "evenodd",
        d: "M119.952 212.92v19.465h8.131v-19.462l5.739 5.739 5.749-5.749-9.806-9.806.004-.003-5.749-5.75-.004.004-.003-.003-5.749 5.749.003.003-9.805 9.805 5.749 5.749z",
        clipRule: "evenodd"
    })), /*#__PURE__*/ React.createElement("defs", null, /*#__PURE__*/ React.createElement("clipPath", {
        id: `file-upload-positive-fidelity-high_svg__a-${id}`
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#fff",
        d: "M0 0h256v256H0z"
    }))));
};
export default SvgFileUploadPositiveFidelityHigh;
